
































import traceQuery from '~/queries/trace.gql'

export default

	props:
		traceData: Object

	data: ->
		loaded: false
		sectionData: {}
		config:
			slidesPerPage: 1
			showDots: false
			showArrows: true

	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'certifications'
				slug: 'certifications'

		@loaded = true

	computed:
		cards: -> @sectionData.certifications.map (card) ->
			title: card.text
			copy: card.simpleWysiwyg
			href: ''
			image: card.image
			includeFor: card.includeFor

		filteredCards: -> @cards.filter (card) =>
			card.includeFor.includes @productType

		block: -> {
			layout: 'small'
			desktopColumns: '3'
			cards: @filteredCards
		}

		productType: ->
			if @traceData?.ItemDesc.includes '100%'
				return '100California'
			else if @traceData?.ItemDesc.includes 'Global Mild'
				return 'globalMild'
			else if @traceData?.ItemDesc.includes 'Global Medium'
				return 'globalMedium'
			else if @traceData?.ItemDesc.includes 'Global Robust'
				return 'globalRobust'

